import React from "react";

import BASELoading from "../../../../../../../@BASE/core/BASELoading";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";

import EMentor from "../components/EMentor";
import Instructions from "../components/Instructions";
import MCInstructions from "../components/MCInstructions";
import PEFeedbackCompletion from "../components/PEFeebackCompletion";

export default function PECompletionEvent(props) {
  const { data, dir, ins = [], course, comments = [] } = props;
  const tl = `${dir === "rtl" ? "text-18" : "text-14"} ${course?.language?.acronym}`.trim();

  if (!data) {
    return <BASELoading />;
  }

  // filer comments by component_id
  const componentCommentsCount = (component) => {
    return comments.filter(
      (comment) =>
        comment.component === component && comment.internality !== true
    ).length;
  };

  const feedbackItem = (ins, type) => {
    const pickInstructions = (key) => {
      return ins.filter((data) => data.label.includes(`-${key}`));
    };

    switch (type) {
      case 1: {
        return pickInstructions("variation-1");
      }
      case 2: {
        return pickInstructions("variation-2");
      }
      case 3: {
        return pickInstructions("variation-3");
      }
      case 4: {
        return pickInstructions("variation-4");
      }
      case 5: {
        return pickInstructions("variation-5");
      }
      default: {
        return pickInstructions("default");
      }
    }
  };

  return (
    <div>
      <style>
        {`
          .wysiwyg p {
            margin: 0px;
          }
        `}
      </style>

      <Typography className="text-16 font-bold p-16 pb-0">
        Page Content:
      </Typography>

      <PEFeedbackCompletion
        ins={feedbackItem(ins, 0)}
        course={course}
        dir={dir}
        tl={tl}
        componentCommentsCount={componentCommentsCount}
        title="Completion Statement"
      />

      <Paper elevation={0} variant="outlined" square className="p-16 m-16">
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Typography className="text-14 font-bold m-0">
                  Summary Statement:
                </Typography>
                <Divider className="my-16" />
              </Grid>
              <Grid item xs={12}>
                <Typography
                  className={`${tl} m-0 wysiwyg`}
                  dir={dir}
                  dangerouslySetInnerHTML={{ __html: data.core.text_tl }}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography
                  className="text-14 m-0 wysiwyg"
                  dangerouslySetInnerHTML={{ __html: data.core.text_en }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>

      {/* {data.core.unlock_id !== 0 && (
        <PEFeedbackCompletion
          ins={feedbackItem(ins, data.core.unlock_id)}
          course={course}
          dir={dir}
          tl={tl}
          componentCommentsCount={componentCommentsCount}
          title="Unlocked Item"
        />
      )} */}
    </div>
  );
}
